import { render, staticRenderFns } from "./ShootAmendment.vue?vue&type=template&id=2e038f00&scoped=true&"
import script from "./ShootAmendment.vue?vue&type=script&lang=js&"
export * from "./ShootAmendment.vue?vue&type=script&lang=js&"
import style0 from "./ShootAmendment.vue?vue&type=style&index=0&id=2e038f00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e038f00",
  null
  
)

export default component.exports